import { InjectionToken } from "@angular/core";

export const EnabledFeaturesInjectionToken = new InjectionToken('enabledFeatures');